var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_254_8123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.25 23.5V19C18.25 18.8011 18.171 18.6103 18.0303 18.4697C17.8897 18.329 17.6989 18.25 17.5 18.25H14.5C14.3011 18.25 14.1103 18.329 13.9697 18.4697C13.829 18.6103 13.75 18.8011 13.75 19V23.5C13.75 23.6989 13.671 23.8897 13.5303 24.0303C13.3897 24.171 13.1989 24.25 13 24.25H8.5C8.30109 24.25 8.11032 24.171 7.96967 24.0303C7.82902 23.8897 7.75 23.6989 7.75 23.5V14.8281C7.75168 14.7243 7.77411 14.6219 7.81597 14.5269C7.85783 14.4319 7.91828 14.3463 7.99375 14.275L15.4937 7.45936C15.632 7.33287 15.8126 7.26273 16 7.26273C16.1874 7.26273 16.368 7.33287 16.5062 7.45936L24.0062 14.275C24.0817 14.3463 24.1422 14.4319 24.184 14.5269C24.2259 14.6219 24.2483 14.7243 24.25 14.8281V23.5C24.25 23.6989 24.171 23.8897 24.0303 24.0303C23.8897 24.171 23.6989 24.25 23.5 24.25H19C18.8011 24.25 18.6103 24.171 18.4697 24.0303C18.329 23.8897 18.25 23.6989 18.25 23.5Z",
    stroke: "#0080FF",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_254_8123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.ea0bdbcf697a35274002b2d121692041.svg";
export { ForwardRef as ReactComponent };